// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3FlOJ","detailsBorder":"styles_detailsBorder__Lgudq"};